<div class="card border mt-3 mt-lg-0" *ngIf="nextGame$ | async as game; else nogame">
  <div class="game rounded m-2">
    <div class="next-game-text">{{ 'next.game.heading' | translate }}</div>
    <div class="text-left d-flex align-items-center mt-lg-4 mt-2">
      <div class="team-logo">
        <img src="{{ getTeamLogoUrl(game.AwayTeamId) }}" draggable="false" />
      </div>
      <div class="ms-3">
        <div class="away-team-name">{{ awayTeamName }}</div>
        <div class="font-size-14 text-start">
          {{ game.Date | date : 'hh:mm aa, EEE MMM dd' }}
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #nogame>
  <a class="cursor-pointer" target="_blank" href="{{ 'tm.account.btn.link' | translate }}">
    <div class="d-flex flex-column justify-content-center align-items-center btn-primary rounded tm-account-card pb-lg-0 pb-2">
      <div class="fw-bold font-size-14 tm-text text-white mb-2">
        {{ 'tm.account.btn.text' | translate }}
      </div>

      <img class="tm-logo" src="assets/images/Logos/tm-logo.png" />
    </div>
  </a>
</ng-template>
